import { API } from 'aws-amplify';
import gql from 'graphql-tag';
import Utilities from '../common/Utilities';

export default class FeedRepository {
  static isFetchingFeed = false;
  static lastFeedType = null;

  static async fetchFeed(
    myFeed,
    ourFeedFilter,
    feedType,
    showDeletedParm,
    now,
    ourNextToken,
    resetList
  ) {
    const topOfFeedQuery = gql`
      query feedByDateNew(
        $userID: ID!
        $showDeleted: Boolean = false
        $nextToken: String = null
        $nowEpoch: Float
      ) {
        feedByUpdatedAt(
          userID: $userID
          limit: 100
          sortDirection: DESC
          nextToken: $nextToken
          filter: {
            type: { ne: inbox }
            showUntilEpoch: { gt: $nowEpoch }
            or: [
              { showAfterEpoch: { lt: $nowEpoch } }
              { showAfterEpoch: { eq: 0 } }
            ]
            and: {
              or: [
                { isDeleted: { eq: false } }
                { isDeleted: { eq: $showDeleted } }
              ]
            }
          }
        ) {
          nextToken
          items {
            activityFeed {
              comments(sortDirection: ASC) {
                items {
                  content
                  createdAt
                  id
                  imageType
                  userID
                  imageName
                  updatedAt
                  isDeleted
                  user {
                    name
                    imageName
                    initials
                    title
                  }
                  parentComment {
                    id
                  }
                }
              }
              emoticons {
                items {
                  id
                  createdAt
                  type
                  user {
                    id
                    imageName
                    name
                    title
                  }
                }
              }
              type
              showAfter
              createdAt
              details
              event
              header
              id
              imageType
              imageName
              updatedAt
              chartType
              chartData
              createdBy
              isDeleted
              changedComment {
                content
                user {
                  id
                  imageName
                  name
                  title
                }
              }
              changedEmoticon {
                type
                createdAt
                user {
                  id
                  imageName
                  name
                  title
                }
              }
              changedCommentEmoticon {
                type
                createdAt
                user {
                  id
                  imageName
                  name
                  title
                }
              }
              createdByUser {
                id
                initials
                imageName
                name
                title
              }
            }
            type
            showAfter
            showAfterEpoch
            showUntilEpoch
            createdAt
            id
            userID
            isRead
            updatedAt
            isDeleted
            user {
              name
              imageName
              initials
              title
            }
          }
        }
      }
    `;

    const feedQuery = gql`
      query feedByDateNew(
        $userID: ID!
        $showDeleted: Boolean = false
        $nextToken: String = null
        $nowEpoch: Float
      ) {
        feedByUpdatedAt(
          userID: $userID
          limit: 100
          sortDirection: DESC
          nextToken: $nextToken
          filter: {
            type: { ne: inbox }
            showUntilEpoch: { eq: 0 }
            or: [
              { showAfterEpoch: { lt: $nowEpoch } }
              { showAfterEpoch: { eq: 0 } }
            ]
            and: {
              or: [
                { isDeleted: { eq: false } }
                { isDeleted: { eq: $showDeleted } }
              ]
            }
          }
        ) {
          nextToken
          items {
            activityFeed {
              comments(sortDirection: ASC) {
                items {
                  content
                  createdAt
                  id
                  imageType
                  userID
                  imageName
                  updatedAt
                  isDeleted
                  user {
                    name
                    imageName
                    initials
                    title
                  }
                  parentComment {
                    id
                  }
                }
              }
              emoticons {
                items {
                  id
                  createdAt
                  type
                  user {
                    id
                    imageName
                    name
                    title
                  }
                }
              }
              type
              showAfter
              createdAt
              details
              event
              header
              id
              imageType
              imageName
              updatedAt
              chartType
              chartData
              createdBy
              isDeleted
              changedComment {
                content
                user {
                  id
                  imageName
                  name
                  title
                }
              }
              changedEmoticon {
                type
                createdAt
                user {
                  id
                  imageName
                  name
                  title
                }
              }
              changedCommentEmoticon {
                type
                createdAt
                user {
                  id
                  imageName
                  name
                  title
                }
              }
              createdByUser {
                id
                initials
                imageName
                name
                title
              }
            }
            type
            showAfter
            showAfterEpoch
            showUntilEpoch
            createdAt
            id
            userID
            isRead
            updatedAt
            isDeleted
            user {
              name
              imageName
              initials
              title
            }
          }
        }
      }
    `;

    const inboxQueryNoDeleted = gql`
      query feedByShowAfter(
        $userID: ID!
        $now: String!
        $nextToken: String = null
        $nowEpoch: Float
      ) {
        feedByShowAfter(
          userID: $userID
          showAfter: { le: $now }
          limit: 100
          sortDirection: DESC
          nextToken: $nextToken
          filter: {
            type: { ne: feed }
            isDeleted: { eq: false }
            or: [
              { showAfterEpoch: { lt: $nowEpoch } }
              { showAfterEpoch: { eq: 0 } }
            ]
            or: [
              { showUntilEpoch: { gt: $nowEpoch } }
              { showUntilEpoch: { eq: 0 } }
            ]
          }
        ) {
          nextToken
          items {
            activityFeed {
              comments(sortDirection: DESC) {
                items {
                  content
                  createdAt
                  id
                  imageType
                  userID
                  imageName
                  updatedAt
                  isDeleted
                  user {
                    name
                    imageName
                    initials
                    title
                  }
                  parentComment {
                    id
                  }
                }
              }
              emoticons {
                items {
                  id
                  createdAt
                  type
                  user {
                    id
                    imageName
                    name
                    title
                  }
                }
              }
              changedComment {
                content
                user {
                  id
                  imageName
                  name
                  title
                }
              }
              changedEmoticon {
                type
                createdAt
                user {
                  id
                  imageName
                  name
                  title
                }
              }
              changedCommentEmoticon {
                type
                createdAt
                user {
                  id
                  imageName
                  name
                  title
                }
              }
              showAfter
              type
              createdAt
              details
              event
              header
              id
              imageType
              imageName
              updatedAt
              chartType
              chartData
              createdBy
              changedID
              isDeleted
              createdByUser {
                id
                initials
                imageName
                name
                title
              }
            }
            showAfter
            showAfterEpoch
            showUntilEpoch
            type
            createdAt
            id
            userID
            isRead
            updatedAt
            user {
              name
              imageName
              initials
              title
            }
          }
        }
      }
    `;

    const inboxQueryAll = gql`
      query feedByShowAfter(
        $userID: ID!
        $now: String!
        $nextToken: String = null
        $nowEpoch: Float
      ) {
        feedByShowAfter(
          userID: $userID
          showAfter: { le: $now }
          nextToken: $nextToken
          limit: 100
          sortDirection: DESC
          filter: {
            type: { ne: feed }
            or: [
              { showAfterEpoch: { lt: $nowEpoch } }
              { showAfterEpoch: { eq: 0 } }
            ]
            or: [
              { showUntilEpoch: { gt: $nowEpoch } }
              { showUntilEpoch: { eq: 0 } }
            ]
          }
        ) {
          nextToken
          items {
            activityFeed {
              comments(sortDirection: DESC) {
                items {
                  content
                  createdAt
                  id
                  imageType
                  userID
                  imageName
                  updatedAt
                  isDeleted
                  user {
                    name
                    imageName
                    initials
                    title
                  }
                  parentComment {
                    id
                  }
                }
              }
              emoticons {
                items {
                  id
                  createdAt
                  type
                  user {
                    id
                    imageName
                    name
                    title
                  }
                }
              }
              changedComment {
                content
                user {
                  id
                  imageName
                  name
                  title
                }
              }
              changedEmoticon {
                type
                createdAt
                user {
                  id
                  imageName
                  name
                  title
                }
              }
              changedCommentEmoticon {
                type
                createdAt
                user {
                  id
                  imageName
                  name
                  title
                }
              }
              showAfter
              type
              createdAt
              details
              event
              header
              id
              imageType
              imageName
              updatedAt
              chartType
              chartData
              createdBy
              isDeleted
              createdByUser {
                id
                initials
                imageName
                name
                title
              }
            }
            showAfter
            showAfterEpoch
            showUntilEpoch
            type
            createdAt
            id
            userID
            isRead
            updatedAt
            user {
              name
              imageName
              initials
              title
            }
          }
        }
      }
    `;
    let filteredFeed = [];

    if (this.isFetchingFeed) {
      return;
    }
    this.isFetchingFeed = true;

    if (!resetList && ourNextToken == null) {
      this.isFetchingFeed = false;
      return [null, null];
    }
    let myNextToken = ourNextToken;
    if (resetList || feedType !== this.lastFeedType) {
      myNextToken = null;
    }
    if (myNextToken === '' && !resetList) {
      this.isFetchingFeed = false;
      return [null, null];
    }

    const nowEpoch = new Date().getTime();

    try {
      let myFeedData = [];
      if (feedType === 'feed') {
        const topOfFeedData = await API.graphql({
          query: topOfFeedQuery,
          variables: {
            userID: global.me.id,
            feedType,
            nextToken: myNextToken,
            nowEpoch,
          },
          limit: 1,
        });
        myFeedData = myFeedData.concat(
          topOfFeedData.data.feedByUpdatedAt.items
        );
        const feedData = await API.graphql({
          query: feedQuery,
          variables: {
            userID: global.me.id,
            feedType,
            nextToken: myNextToken,
            nowEpoch,
          },
          limit: 1,
        });
        for (const item of feedData.data.feedByUpdatedAt.items) {
          myFeedData[myFeedData.length] = item;
        }
        myNextToken = feedData.data.feedByUpdatedAt.nextToken;
      } else {
        if (showDeletedParm) {
          const feedData = await API.graphql({
            query: inboxQueryAll,
            variables: {
              userID: global.me.id,
              now: Utilities.endOfToday(now),
              nextToken: myNextToken,
              nowEpoch,
            },
            limit: 1,
          });
          myFeedData = myFeedData.concat(feedData.data.feedByShowAfter.items);
          myNextToken = feedData.data.feedByShowAfter.nextToken;
        } else {
          const feedData = await API.graphql({
            query: inboxQueryNoDeleted,
            variables: {
              userID: global.me.id,
              now: Utilities.endOfToday(now),
              nextToken: myNextToken,
              nowEpoch,
            },
            limit: 1,
          });
          myFeedData = myFeedData.concat(feedData.data.feedByShowAfter.items);
          myNextToken = feedData.data.feedByShowAfter.nextToken;
        }
      }

      if (!resetList && this.lastFeedType === feedType) {
        filteredFeed = myFeed;
      }

      if (ourFeedFilter === 2) {
        // Show everything
        for (const feedItem of myFeedData) {
          if (feedItem.activityFeed.isDeleted) {
            continue;
          }
          if (feedItem.activityFeed.createdByUser != null) {
            feedItem.initials = feedItem.activityFeed.createdByUser.initials;
            feedItem.name = feedItem.activityFeed.createdByUser.name;
            if (feedItem.activityFeed.createdByUser.title != null) {
              feedItem.userTitle = feedItem.activityFeed.createdByUser.title;
            } else {
              feedItem.userTitle = '';
            }
          } else {
            feedItem.initials = 'PAI';
            feedItem.name = 'PaivBot';
            feedItem.userTitle = '';
          }
          filteredFeed[filteredFeed.length] = feedItem;
        }
      } else {
        //
        for (const feedItem of myFeedData) {
          if (feedItem.activityFeed.isDeleted) {
            continue;
          }
          if (feedItem.isRead === (ourFeedFilter === 1)) {
            if (
              feedItem.activityFeed !== null &&
              feedItem.activityFeed.createdByUser !== null
            ) {
              feedItem.initials = feedItem.activityFeed.createdByUser.initials;
              feedItem.name = feedItem.activityFeed.createdByUser.name;
              if (feedItem.activityFeed.createdByUser.title != null) {
                feedItem.userTitle = feedItem.activityFeed.createdByUser.title;
              } else {
                feedItem.userTitle = '';
              }
            } else {
              feedItem.initials = 'PAI';
              feedItem.name = 'PaivBot';
              feedItem.userTitle = '';
            }
            filteredFeed[filteredFeed.length] = feedItem;
          }
        }
      }

      const missionIDs = [];
      for (const feedItem of filteredFeed) {
        if (feedItem.activityFeed.changedEmoticon != null) {
          feedItem.activityFeed.changedEmoticon.color = 'gray';
          feedItem.activityFeed.changedEmoticon.symbol = '?';
          for (const emoticon of global.appSettings.emoticons) {
            if (emoticon.key === feedItem.activityFeed.changedEmoticon.type) {
              feedItem.activityFeed.changedEmoticon.color = emoticon.color;
              feedItem.activityFeed.changedEmoticon.symbol = emoticon.symbol;
              break;
            }
          }
        }
        if (feedItem.activityFeed.changedCommentEmoticon != null) {
          feedItem.activityFeed.changedCommentEmoticon.color = 'gray';
          feedItem.activityFeed.changedCommentEmoticon.symbol = '?';
          for (const emoticon of global.appSettings.emoticons) {
            if (
              emoticon.key === feedItem.activityFeed.changedCommentEmoticon.type
            ) {
              feedItem.activityFeed.changedCommentEmoticon.color =
                emoticon.color;
              feedItem.activityFeed.changedCommentEmoticon.symbol =
                emoticon.symbol;
              break;
            }
          }
        }
        //
        //  Filter out the child comments (so we only see the parents in the first level of the feed
        //
        const filteredComments = [];

        for (const comment of feedItem.activityFeed.comments.items) {
          if (comment.parentComment == null && !comment.isDeleted) {
            filteredComments[filteredComments.length] = comment;
          }
        }
        feedItem.activityFeed.comments.items = filteredComments;

        if (feedItem.activityFeed.chartType === 'missionLeader') {
          const event = JSON.parse(feedItem.activityFeed.event);
          if (missionIDs.includes(event.missionID)) {
            feedItem.activityFeed.skipDetails = true;
          } else {
            feedItem.activityFeed.skipDetails = false;
            missionIDs[missionIDs.length] = event.missionID;
          }
        }
      }
      if (feedType === 'inbox' || feedType === 'feed_and_inbox') {
        const count = filteredFeed.length;
        if (global.notificationCount !== count) {
          global.notificationCount = count;
          for (const handler of global.updateNotificationHandler) {
            handler(count);
          }
          for (const handler of global.refreshOnNotificationHandler) {
            handler(count);
          }
        }
      }
    } catch (err) {
      console.error('fetchFeed(): error fetching feed', err);
    }
    this.isFetchingFeed = false;
    this.lastFeedType = feedType;
    return [myNextToken, filteredFeed];
  }
}
